import script from "./LoadingSpinner.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoadingSpinner.vue?vue&type=script&lang=ts&setup=true"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=573ba29a&lang=css"

const __exports__ = script;

export default __exports__